import React, {Component, ReactElement} from 'react'
import {NatGetCondominiumAuthed} from './repository/NatGetCondominiumAuthed';
import NatCondominiumRepo from './repository/NatCondominiumRepo';
import NatSessionRepo, {PostResidentCondominiumSelectParams} from '../session/repository/NatSessionRepo';
import {NatPostResidentCondominiumSelect} from '../session/repository/NatPostResidentCondominiumSelect';
import {MainContainer} from '../../../styledComponents/ContentsArea';
import NatResidentCondominiumSelectFormComponent from './resident/NatResidentCondominiumSelectFormComponent';
import NatResidentCondominiumSelectReadComponent from './resident/NatResidentCondominiumSelectReadComponent';
import {CondominiumGroupData, NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {LOGIN_MODE} from '../../../CodeMaster'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey,
} from '../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {Location} from 'react-router-dom'

interface Props {
    condominiumRepo: NatCondominiumRepo
    sessionRepo: NatSessionRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    location: Location
}

interface States {
    inputMailAddressValue: string
    inputMailAddressConfirmValue: string
    changeMailAddressButtonDispFlg: boolean
    condominium: NatGetCondominiumAuthed | null
    condominiumGroup: NatGetCondominiumGroup
    condominiumGroupInfo: CondominiumGroupData[] | null
    subCondominiumGroup: NatGetCondominiumGroup
    isLoadCompleted: boolean
}

class NatResidentCondominiumSelectPage extends Component<Props & ResidentPagePropsSet, States> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            inputMailAddressValue: '',
            inputMailAddressConfirmValue: '',
            changeMailAddressButtonDispFlg: false,
            condominium: null,
            condominiumGroup: {
                details: null,
                informations: [],
                requestError: null,
                requestItemErrors: [],
            },
            condominiumGroupInfo: null,
            subCondominiumGroup: {
                details: null,
                informations: [],
                requestError: null,
                requestItemErrors: [],
            },
            isLoadCompleted: false,
        }

        this.setSearchConditions = this.setSearchConditions.bind(this)
        this.CondominiumSelectClick = this.CondominiumSelectClick.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 物件抽出
            await this.setSearchConditions('', true)
            if (NatResidentLoginInfoSessionStorageHelper.getStringItemOrNull(
                ResidentLoginInfoSessionStorageKey.LOGIN_MODE) === LOGIN_MODE.ADMIN.value) {
                // 所属物件グループ情報と引き継ぎ物件グループ情報を取得する
                let condominiumGroup: Nullable<NatGetCondominiumGroup> =
                    await NatAsyncCallFunction(
                        this.props.condominiumGroupRepo.getCondominiumGroup.bind(
                            this.props.condominiumGroupRepo), this.props.navigate)
                let subCondominiumGroup: Nullable<NatGetCondominiumGroup> =
                    await NatAsyncCallFunction(
                        this.props.condominiumGroupRepo.getSubCondominiumGroup.bind(
                            this.props.condominiumGroupRepo), this.props.navigate)

                // 所属物件グループと引き継ぎ物件グループのどちらかがもう一方の配下である場合、階層が高い方のみ保存する
                if (condominiumGroup?.details && subCondominiumGroup?.details) {
                    const condominiumGroupData = condominiumGroup.details
                    const subCondominiumGroupData = subCondominiumGroup.details
                    const condominiumGroupIdList = this.collectCondominiumGroupIdList(condominiumGroupData)
                    const subCondominiumGroupIdList = this.collectCondominiumGroupIdList(subCondominiumGroupData)
                    if (condominiumGroupIdList.some(id => id === subCondominiumGroupData.level1CondominiumGroupId)) {
                        subCondominiumGroup = null
                    }
                    if (subCondominiumGroupIdList.some(id => id === condominiumGroupData.level1CondominiumGroupId)) {
                        condominiumGroup = null
                    }
                }

                if (condominiumGroup) {
                    this.setState({
                        condominiumGroup: condominiumGroup,
                    })
                }
                if (subCondominiumGroup) {
                    this.setState({
                        subCondominiumGroup: subCondominiumGroup,
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

// 物件抽出
    async setSearchConditions(condition: string, initialDisplay?: boolean): Promise<void> {
        if (!initialDisplay) {
            await this.props.eventEmitter.showLoading()
        }
        try {
            // 物件一覧
            const condominium: Nullable<NatGetCondominiumAuthed> =
                await NatAsyncCallFunction(
                    this.props.condominiumRepo.getCondominiumAuthed.bind(
                        this.props.condominiumRepo, condition), this.props.navigate);
            if (condominium) {
                this.setState({condominium: condominium})
            }
        } finally {
            if (!initialDisplay) {
                this.props.eventEmitter.closeLoading()
            }
        }
    }

    // 物件選択
    async CondominiumSelectClick(
        condominiumCd: string,
        condominiumGroupId: number,
        ridgeCd: string,
        roomNumber: string,
    ): Promise<void> {
        const request: PostResidentCondominiumSelectParams = {
            condominiumCd: condominiumCd,
            ridgeCd: ridgeCd,
            roomNumber: roomNumber,
        }
        await this.props.eventEmitter.showLoading()
        try {
            // 選択した物件が引き継ぎ物件グループ配下であるなら、所属物件グループを引き継ぎ物件グループに変更する
            if (this.state.subCondominiumGroup.details) {
                const subCondominiumGroupData = this.state.subCondominiumGroup.details
                const subCondominiumGroupIdList = this.collectCondominiumGroupIdList(subCondominiumGroupData)
                if (subCondominiumGroupIdList.some(id => id === condominiumGroupId)) {
                    const subCondominiumGroupId = Number(subCondominiumGroupData.level1CondominiumGroupId)
                    await NatAsyncCallFunction(
                        this.props.sessionRepo.changeBelongCondominiumGroupForResidentSite.bind(
                            this.props.sessionRepo, subCondominiumGroupId), this.props.navigate)
                }
            }

            const selectInfo: Nullable<NatPostResidentCondominiumSelect> =
                await NatAsyncCallFunction(
                    this.props.sessionRepo.postResidentCondominiumSelect.bind(
                        this.props.sessionRepo, request), this.props.navigate);

            if (selectInfo && selectInfo.role !== null) {
                NatResidentLoginInfoSessionStorageHelper.setSessionStorageCondominiumInfo(selectInfo)

                if (this.props.location.state && this.props.location.state.seniurl) {
                    this.props.navigate(`${this.props.location.state.seniurl}`)
                } else {
                    this.props.navigate(
                        `/resident/mypage`,
                    )
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <MainContainer>
                    <NatResidentCondominiumSelectFormComponent
                        condominiumGroup={this.state.condominiumGroup}
                        subCondominiumGroup={this.state.subCondominiumGroup}
                        setSearchConditions={this.setSearchConditions}
                    />
                    <NatResidentCondominiumSelectReadComponent
                        condominium={this.state.condominium}
                        CondominiumSelectClick={this.CondominiumSelectClick}
                    />
                </MainContainer>
            </>
        )
    }

    private collectCondominiumGroupIdList(condominiumGroupData: CondominiumGroupData): (string | number)[] {
        const groupIdList = condominiumGroupData.level2CondominiumGroupInfo?.flatMap(info2 => {
            return [
                ...info2.level3CondominiumGroupInfo?.flatMap(info3 => {
                    return [
                        ...info3.level4CondominiumGroupInfo?.map(info4 => {
                            return info4.level4CondominiumGroupId
                        }) ?? [],
                        info3.level3CondominiumGroupId,
                    ]
                }) ?? [],
                info2.level2CondominiumGroupId,
            ]
        }) ?? []
        return [condominiumGroupData.level1CondominiumGroupId, ...groupIdList]
    }
}

export default createResidentPage(NatResidentCondominiumSelectPage)
